import WomFavicon from './favicon.ico';
import WomFavicon57 from './apple-icon-57x57.png';
import WomFavicon60 from './apple-icon-60x60.png';
import WomFavicon72 from './apple-icon-72x72.png';
import WomFavicon76 from './apple-icon-76x76.png';
import WomFavicon114 from './apple-icon-114x114.png';
import WomFavicon120 from './apple-icon-120x120.png';
import WomFavicon144 from './apple-icon-144x144.png';
import WomFavicon152 from './apple-icon-152x152.png';
import WomFavicon180 from './apple-icon-180x180.png';
import WomFavicon192 from './android-icon-192x192.png';
import WomFavicon32 from './favicon-32x32.png';
import WomFavicon96 from './favicon-96x96.png';
import WomFavicon16 from './favicon-16x16.png';
import WomFavicon36 from './android-icon-36x36.png';
import WomFavicon48 from './android-icon-48x48.png';

const favicons = [
  { rel: 'icon', type: 'image/x-icon', href: WomFavicon },
  { rel: 'mask-icon', href: WomFavicon },
  { rel: 'shortcut icon', type: 'image/x-icon', href: WomFavicon },
  { rel: 'apple-touch-icon', sizes: '57x57', href: WomFavicon57 },
  { rel: 'apple-touch-icon', sizes: '60x60', href: WomFavicon60 },
  { rel: 'apple-touch-icon', sizes: '72x72', href: WomFavicon72 },
  { rel: 'apple-touch-icon', sizes: '76x76', href: WomFavicon76 },
  { rel: 'apple-touch-icon', sizes: '114x114', href: WomFavicon114 },
  { rel: 'apple-touch-icon', sizes: '120x120', href: WomFavicon120 },
  { rel: 'apple-touch-icon', sizes: '144x144', href: WomFavicon144 },
  { rel: 'apple-touch-icon', sizes: '152x152', href: WomFavicon152 },
  { rel: 'apple-touch-icon', sizes: '180x180', href: WomFavicon180 },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '180x180',
    href: WomFavicon192,
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '180x180',
    href: WomFavicon32,
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '180x180',
    href: WomFavicon96,
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '180x180',
    href: WomFavicon16,
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '48x48',
    href: WomFavicon48,
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '36x36',
    href: WomFavicon36,
  },
];

export default favicons;
